import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const validPage = (value) => {
  const page = Number(value);
  return Number.isInteger(page) && page > 0 ? page : null;
};

const pageFromLegacyUrl = (url) => {
  if (typeof url !== "string" || !url) return null;
  try {
    return validPage(new URL(url, "https://subscription-history.invalid").searchParams.get("page"));
  } catch (_error) {
    return null;
  }
};

// Legacy Laravel paginator links may contain an absolute host. Keep only the
// page token and rebuild the request against the configured Flask API.
const localSubscriptionAction = (route, values = {}) => {
  const page = validPage(values.page) || pageFromLegacyUrl(values.next_page_url);
  return `${route}${page ? `?page=${page}` : ""}`;
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const result = values && values.result ? values.result : "";
  let pagination = true;
  if (values) {
    if (values.id) {

    }
    if (values.option) {

    }
    if (values.pagination) {
      void (values.pagination);
    }
  }
  const action = localSubscriptionAction("afterlogin/salonsubscriptionplan/view", values);
  const data = {
      auth_key: auth_key,
      action: action,
      // pagination: pagination,
      pagination: pagination, //true or false
      id: values && values.id ? values.id : "",
      result: result, //business_name,owner_name
    };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};
const paymentshistory = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const type = values && values.type ? values.type : "";
  const result = values && values.result ? values.result : "";

  if (values) {
    if (values.id) {

    }
    if (values.option) {

    }
    if (values.pagination) {
      void (values.pagination);
    }
  }
  const action = localSubscriptionAction("afterlogin/salons/paymenthistory", values);
  const data = {
      auth_key: auth_key,
      action: action,
      // pagination: pagination,
      type:type,
      pagination: false, //true or false
      id: values && values.id ? values.id : "",
      result: result, //business_name,owner_name
    };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const salonsubscriptionplanApiController = {
  view,
  paymentshistory
};
export default salonsubscriptionplanApiController;
